<template>
  <v-app :dark="dark">
    <AppMainToolbar @changeMenu="changeMenu" />
    <AppMainMenu v-model="isShowingMenu" />
    <v-main>
      <transition name="fade" mode="out-in">
        <router-view style="padding: 20px; padding-top: 10px;" />
      </transition>
    </v-main>
    <AppMainFooter class="footer-card" />

    <AppSnackbar />

    <AppMainConfirmDialog ref="confirm" />

    <AppMainJustifyDialog ref="justify" />
  </v-app>
</template>

<script>
import AppMainToolbar from "@/components/layout/AppMainToolbar.vue";
import AppSnackbar from "@/components/layout/AppSnackbar.vue";
import AppMainMenu from "@/components/layout/AppMainMenu.vue";
import AppMainConfirmDialog from "@/components/layout/AppMainConfirmDialog.vue";
import AppMainJustifyDialog from "@/components/layout/AppMainJustifyDialog.vue";
import AppMainFooter from "@/components/layout/AppMainFooter.vue";

export default {
  name: "App",
  components: {
    AppMainToolbar,
    AppSnackbar,
    AppMainMenu,
    AppMainConfirmDialog,
    AppMainJustifyDialog,
    AppMainFooter
  },
  data() {
    return {
      isShowingMenu: false,
      dark: true
    };
  },
  methods: {
    changeMenu() {
      this.isShowingMenu = !this.isShowingMenu;
    }
  },
  mounted() {
    this.$root.$confirm = this.$refs.confirm.open;
    this.$root.$justify = this.$refs.justify.open;
  },
  created() {
    this.$axios.defaults.baseURL = this.$store.state.urlAPI;

    this.$ga.set("userId", this.$keycloak.tokenParsed.subject);
    this.$ga.event(
      "login",
      "login",
      this.$keycloak.tokenParsed.preferred_username
    );

    this.$store.commit("mtChangeToken", this.$keycloak.tokenParsed);

    this.$store.dispatch("actLoadExtensionistas");
    this.$store.dispatch("actLoadTabelaConfiguracao");
    this.$store.dispatch("actLoadTabelasMetaMortalidade");
    this.$store.dispatch("actLoadEstabelecimentos");
    this.$store.dispatch("actLoadTiposAdmFarmaco");
    // this.$store.dispatch('actLoadMensagensNaoLidas')
  }
};
</script>

<style>
.theme--light.v-icon {
  color: #10303d;
}

.footer-card {
  position: relative !important;
  z-index: 999999;
}
</style>
